import { render, staticRenderFns } from "./CountDownTeaser.vue?vue&type=template&id=024ad04c&scoped=true&"
import script from "./CountDownTeaser.vue?vue&type=script&lang=js&"
export * from "./CountDownTeaser.vue?vue&type=script&lang=js&"
import style0 from "./CountDownTeaser.vue?vue&type=style&index=0&id=024ad04c&prod&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "024ad04c",
  null
  
)

export default component.exports